<!-- 视频上公告栏 -->
<template>
    <div class="d-flex align-items-stretch flex-grow-1 top-0 start-0 end-0 bg-dark bg-opacity-50 text-light index-2">
        <i class="bi bi-megaphone-fill mx-2 py-1 text-warning"></i>
        <div v-if="$route.name!='share'" class="flex-grow-1 w-0 notice-short d-flex px-2 overflow-hidden">
            <div class="rounded-pill position-relative top-50 marquee text-nowrap d-flex align-items-center">
                <span>{{notice}}</span>
            </div>
        </div>
        <div class="notice-long position-absolute bg-dark bg-opacity-50 p-2 rounded w-100 index-1 top-100">{{notice}}</div>
    </div>
</template>
<script>

export default {
    inject: {
        //公告内容
        notice:{
            default:""
        }
    }
}
</script>